import CustomerDetailsContainer from './CustomerDetails'

const CustomerDetailsPage = () => <div style={{ marginTop: 40 }}>{<CustomerDetailsContainer />}</div>

export default CustomerDetailsPage
